export function unreachable(x: never): never {
  throw new Error('bug');
}

export function promiseHang(): Promise<any> {
  return new Promise(() => undefined);
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/utils.ts